export const getKoreanNoteName = (midi) => {
    const noteNames = ['도', '도#', '레', '레#', '미', '파', '파#', '솔', '솔#', '라', '라#', '시'];
    // MIDI 60 is C4 (standard), but in Korean karaoke convention often C4 is '2옥' or '3옥' depending on standard. 
    // Usually C4 (Middle C) is regarded as "1옥타브 도" or "3옥타브 도" depending on gender/context.
    // Let's follow a standard convention: C3=1옥, C4=2옥, C5=3옥.
    // MIDI 48 = C3, 60 = C4, 72 = C5.

    // Adjusted logic: MIDI 60 (C4) -> 2옥 도 (if we follow C3=1옥 base)
    // However user asked for "3옥(도)". 
    // In many high note challenges, "3옥 도" usually refers to C5 (High C).
    // So: C5 (72) -> 3옥.
    // Formula: (midi / 12) - 3;
    // 72 / 12 = 6.  6 - 3 = 3. Correct.

    const standardOctave = Math.floor(midi / 12) - 3;
    const noteIndex = midi % 12;
    const noteName = noteNames[noteIndex];

    return `${standardOctave}옥 ${noteName}`;
};

export const noteToMidi = (noteStr) => {
    // Format: "C4", "C#4", "Db4"
    // Regex to split Note + Octave
    const match = noteStr.match(/^([A-G][#b]?)(-?\d+)$/);
    if (!match) {
        console.warn(`Invalid note format: ${noteStr}`);
        return 60; // Default C4
    }

    let [, note, octStr] = match;
    const octave = parseInt(octStr);

    const NOTE_OFFSETS = {
        'C': 0, 'C#': 1, 'Db': 1,
        'D': 2, 'D#': 3, 'Eb': 3,
        'E': 4,
        'F': 5, 'F#': 6, 'Gb': 6,
        'G': 7, 'G#': 8, 'Ab': 8,
        'A': 9, 'A#': 10, 'Bb': 10,
        'B': 11
    };

    const offset = NOTE_OFFSETS[note.toUpperCase()];
    // MIDI note = (octave + 1) * 12 + offset
    // C4 = 60. (4+1)*12 + 0 = 60. Correct.
    return (octave + 1) * 12 + offset;
};

export const isNoteMatch = (targetMidi, userMidi, tolerance = 1) => {
    return Math.abs(targetMidi - userMidi) <= tolerance;
};

export const midiToNoteName = (midi) => {
    const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
    if (midi < 0 || midi > 127) return '?';
    const octave = Math.floor(midi / 12) - 1;
    const note = notes[midi % 12];
    return `${note}${octave}`;
};
